<template>
    <div class="dashboard-widget-content">
        <template v-if="!value.ShowOptions">
            <chart-card-dashboard-wings no-footer>
                <bar-chart :data="demoData()" :xAxis="demoXAxis()"></bar-chart>
            </chart-card-dashboard-wings>
        </template>
        <template v-else>
            <widget-options>
                <md-field>
                    <label>{{ $t('widget.options.update') }}</label>
                    <md-select v-model="options.update">
                        <md-option value="10">10 мин</md-option>
                        <md-option value="0">Нет</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.interval') }}</label>
                    <md-select v-model="options.interval">
                        <md-option value="hour">предыдущий час</md-option>
                        <md-option value="today">сегодня</md-option>
                        <md-option value="yesterday">вчера</md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.chanel') }}</label>
                    <md-select v-model="options.chanel">
                        <md-option v-for="transport in this.$store.getters.transports" :value="transport.name" :key="transport.id">
                          {{ transport.name }}
                        </md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>{{ $t('widget.options.group_by') }}</label>
                    <md-select v-model="options.group_by">
                        <md-option value="service_provider">по поставщикам услуг</md-option>
                        <md-option value="partner">по клиентам</md-option>
                    </md-select>
                </md-field>
            </widget-options>
        </template>
    </div>
</template>

<script>
  import widgetMixin from './mixin'
  import { DateTime,Settings } from 'luxon'
  import {TrafficSending} from "@/services/Widgets";

  import {ChartCard} from 'wings-ui-components';
  export default {
    name: "TrafficSending",
    mixins:[widgetMixin],
    props:{
      value:{},
      fullSize:{default:false}
    },
    data(){return{
      options:{
        update:'10',
        interval:'hour',
        chanel:'SMS',
        group_by:'partner',
      },
    }},

    methods:{
      title(){
        let title = this.$t('widget.channel.'+this.options.chanel)+' '+ this.$t('widget.MessagesByGroup.options.group_by.'+this.options.group_by);

        switch (this.options.interval) {
          case 'hour':
            title += ' с ' + DateTime.fromISO(this.options.date_from).toFormat('HH:mm');
            title += ' до ' + DateTime.fromISO(this.options.date_to).toFormat('HH:mm');
            break;
          case 'today':
            title += ' сегодня';
            break;
          case 'yesterday':
            title += ' вчера';
            break;
        }

        return title;
      },
      randomInteger(min, max) {
        // случайное число от min до (max+1)
        let rand = min + Math.random() * (max + 1 - min);
        return Math.floor(rand);
      },
      demoData(){
        let arr = [];
        for (let i = 0; i < 20; i++ ) {
          arr.push(this.randomInteger(1,12000));
        }
        return arr
      },
      demoXAxis(){
        let arr = [];
        let cur = DateTime.local();
        for (let i = 0; i < 20; i++ ) {
          arr.push(cur.toFormat('dd LLL HH:ss'));
          cur = cur.plus({hour:-1})
        }
        return arr.reverse()
      },
      async getData() {
        switch (this.options.interval) {
          case 'hour':
            this.options.date_from = DateTime.local().plus({hour:-1}).toISO();
            this.options.date_to = DateTime.local().toISO();
            break;
          case 'today':
            this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
            this.options.date_to = DateTime.local().set({second: 0, millisecond: 0}).toISO();
            break;
          case 'yesterday':
            this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).plus({day: -1}).toISO();
            this.options.date_to = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
            break;
        }

        let filter = {
          date_from: this.options.date_from,
          date_to: this.options.date_to,
          transport: this.options.chanel,
          group_by: this.options.group_by,
        };

        let response = await TrafficSending(filter);
        if (response.data) {

        }

        this.updateTitle();
      },
      intervalFunc() {
        clearInterval(this.timer);
        const update = (60000 * parseInt(this.options.update)) || 0;
        if (update > 0) {
          this.getData();
          this.timer = setInterval(() => this.getData(), update);
        }
      }
    },
    watch: {
      'options'() {
        this.intervalFunc();
      }
    },
    mounted() {
      this.intervalFunc();
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
    created() {
      Settings.defaultLocale = this.$i18n.locale;
    }
  }
</script>
